import type { LottieComponentProps } from 'lottie-react';
import React from 'react';
import { ErrorBoundary } from 'reactApp/ui/ErrorBoundary/ErrorBoundary';

const Lottie = React.lazy(() => import(/* webpackPreload: true, webpackChunkName: "lottie" */ 'lottie-react'));

const LottieWrapped = (props: LottieComponentProps) => (
    <ErrorBoundary>
        {/* @ts-ignore */}
        <Lottie {...props} />
    </ErrorBoundary>
);

export default LottieWrapped;
